import React, { useCallback } from 'react';

import Flex from '@decisiv/ui-components/lib/components/Flex';
import SearchInput from '@decisiv/ui-components/lib/components/SearchInput';
import { H1, P } from '@decisiv/ui-components/lib/components/Typography';

import { t } from '@lingui/macro';
import PageHead from 'components/PageHead';

import { useTeams } from './contexts/TeamsContext';
import CreateTeamModal from './CreateTeamModal';
import TeamModalProvider from './CreateTeamModal/contexts/TeamModalContext';
import { TeamsPageContent } from './TeamsPageContent';

export default function TeamsPage() {
  const { teamKey, setTeamKey } = useTeams();

  const handleTeamKeyChange = useCallback(
    ({ target: { value } }) => {
      setTeamKey(value);
    },
    [setTeamKey],
  );

  return (
    <>
      <PageHead titleParts={[t`Teams`, t`Decisiv Super Admin`]} />

      <Flex>
        <Flex flex={1} paddingX={2} paddingY={1}>
          <Flex flex={1} alignItems="center" justifyContent="space-between">
            <Flex alignItems="center">
              <H1 weight="regular">{t`Teams`}</H1>
              <Flex alignItems="center" marginLeft={2}>
                <P size="small" marginRight={0.5}>
                  {t`Team Key:`}
                </P>
                <SearchInput
                  aria-label={t`Filter teams by key`}
                  searchOn="change"
                  value={teamKey}
                  size="small"
                  onChange={handleTeamKeyChange}
                />
              </Flex>
            </Flex>
            <TeamModalProvider>
              <CreateTeamModal />
            </TeamModalProvider>
          </Flex>
        </Flex>
      </Flex>
      <Flex flexDirection="column" style={{ overflow: 'hidden' }}>
        <TeamsPageContent />
      </Flex>
    </>
  );
}
